module.exports = __webpack_public_path__ + "static/media/home-section2-content-image-1x.0fa483a5.jpg";